import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
    "saved_searches": {
        id: "common.search_filter.filter_dropdown.saved_views",
        defaultMessage: "Saved Views",
    }
})


class FilterDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: props.options || [],
            filterName: props.filterName || this.props.intl.formatMessage(messages["saved_searches"]),
            filterCleared: props.isFilterCleared || false,
            isActive: false,
        }

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    componentDidUpdate(prevProps, nextProps) {
        if (!this.isEqual(prevProps.options, this.props.options)) {
            this.setState({
                options: this.props.options,
            }, () => {

                if (this.props.savedFilterId) {
                    this.handleOnClick(this.props.savedFilterId);
                }
            })
        }
        if (prevProps.savedFilterId !== this.props.savedFilterId && !this.props.savedFilterId) {
            this.setState({
                filterCleared: this.props.isFilterCleared,
                filterName: this.props.intl.formatMessage(messages["saved_searches"]),
                isActive: false,
            });
        }
    }

    isEqual(pastFilters, presentFilters) {
        var isEqual = true;
        if (Object.keys(pastFilters).length !== Object.keys(presentFilters).length) {
            isEqual = false;
        }
        else if (pastFilters && Object.keys(pastFilters).length > 0) {
            Object.keys(pastFilters).forEach(elem => {
                if (pastFilters[elem].attributes.name !== presentFilters[elem].attributes.name) {
                    this.setState({
                        filterName: presentFilters[elem].attributes.name,
                    })
                    isEqual = false;
                } else if (pastFilters[elem].attributes.option !== presentFilters[elem].attributes.option) {
                    isEqual = false;
                } else if (pastFilters[elem].attributes.content !== presentFilters[elem].attributes.content) {
                    isEqual = false;
                }
            })
        }
        return isEqual;
    }

    handleOnClick(filterId) {
        let createdByCurrentUser = false;
        var filtersToUse;
        const filter = this.props.options.find(filter => filter.id === filterId)
        if (filter) {
            filtersToUse = filter.attributes.content;
            this.setState({
                filterName: filter.attributes.name,
                isActive: true,
            })

            if (filter.attributes.createdBy === this.props.userId) {
                createdByCurrentUser = true;
            }
            this.props.onChangeSavedFilter(filterId, filtersToUse, filter.attributes.view)
            this.props.createdByCurrentUser(createdByCurrentUser)
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        let isActive = this.state.isActive == true ? "btn btn-primary dropdown-toggle w-100" : "btn btn-outline-primary dropdown-toggle w-100";
        let filterName = this.state.filterName
        let optionItems = [];
        let sharedOptionItems = [];
        this.props.options.forEach((filter) => {
            if (filter.attributes.createdBy === this.props.userId) {
                optionItems.push(
                    <a className="dropdown-item" onClick={() => this.handleOnClick(filter.id)} key={filter.id} href="#">
                        {filter.attributes.name}
                    </a>);
            } else {

                sharedOptionItems.push(
                    <a className="dropdown-item" onClick={() => this.handleOnClick(filter.id)} key={filter.id} href="#">
                        {filter.attributes.name}
                    </a>);
            }

        });
        let emptyDropdownMenu =
            <div className="dropdown-menu">
                <h6 className="dropdown-header">
                    <FormattedMessage
                        id="common.search_filter.filter_dropdown.no_saved_searches"
                        defaultMessage="No saved searches"
                    />
                </h6>
            </div>;

        let mySearches =
            <h6 className="dropdown-header">
                <FormattedMessage
                    id="common.search_filter.filter_dropdown.my_views"
                    defaultMessage="My Views"
                />
            </h6>;

        let sharedSearches =
            <h6 className="dropdown-header">
                <FormattedMessage
                    id="common.search_filter.filter_dropdown.shared_views"
                    defaultMessage="Shared Views"
                />
            </h6>;

        let dropdownMenu;

        if (this.props.options.length === 0) {
            dropdownMenu = emptyDropdownMenu
        } else if (optionItems.length === 0) {
            dropdownMenu =
                <div className="dropdown-menu">
                    {sharedSearches}
                    {sharedOptionItems}
                </div>
        } else if (sharedOptionItems.length === 0) {
            dropdownMenu =
                <div className="dropdown-menu">
                    {mySearches}
                    {optionItems}
                </div>
        } else {
            dropdownMenu =
                <div className="dropdown-menu">
                    {mySearches}
                    {optionItems}
                    {sharedSearches}
                    {sharedOptionItems}
                </div>
        }
        return (

            <div className="input-group-append">
                <button className={isActive} type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{filterName}</button>
                {dropdownMenu}
            </div>
        );
    }
}
export default injectIntl(FilterDropdown);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-menu/filterDropdown.component.jsx